'use client';

import { __assign } from '../../_virtual/_tslib.js';
import { NOTIFY_ACTION } from './action.js';
import { mapJobInvitationNotificationReducer } from './childReducers/mapJobInvitationNotifications.js';

var notificationReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case NOTIFY_ACTION.SHOW: {
            return __assign(__assign({}, state), { isOpen: true });
        }
        case NOTIFY_ACTION.HIDE: {
            return __assign(__assign({}, state), { isOpen: false });
        }
        case NOTIFY_ACTION.SET_NOTIFY_COUNT: {
            var countPayload = payload;
            var notifyCount = countPayload.type === 'notify'
                ? { notificationCount: countPayload.value }
                : { notificationBellCount: countPayload.value };
            return __assign(__assign({}, state), notifyCount);
        }
        case NOTIFY_ACTION.SET_LOADING: {
            return __assign(__assign({}, state), { isLoading: payload });
        }
        case NOTIFY_ACTION.SET_NOTIFICATIONS: {
            return __assign(__assign({}, state), { notifications: payload, isLoading: false });
        }
        case NOTIFY_ACTION.SET_FILTER: {
            return __assign(__assign({}, state), { filter: payload });
        }
        case NOTIFY_ACTION.SET_NOTIFY_READ: {
            var notifyKey_1 = payload;
            // Deep-clone notifications list first
            var newNotifications = JSON.parse(JSON.stringify(state.notifications));
            var indexKey = newNotifications.findIndex(function (item) { return item.notifyKey === notifyKey_1; });
            if (indexKey < 0) {
                return __assign({}, state);
            }
            newNotifications[indexKey].isRead = 1;
            // Set back to state
            return __assign(__assign({}, state), { notifications: newNotifications });
        }
        case NOTIFY_ACTION.PUSH_TO_NOTIFICATIONS: {
            var newNotifications = JSON.parse(JSON.stringify(state.notifications));
            // Push to first index of notifications
            newNotifications.unshift(payload);
            return __assign(__assign({}, state), { notifications: newNotifications });
        }
        case NOTIFY_ACTION.MAP_JOB_INVITATION_NOTIFICATIONS: {
            var jobInvitations = payload;
            // Using child reducer
            return mapJobInvitationNotificationReducer({
                state: state,
                jobInvitations: jobInvitations
            });
        }
        case NOTIFY_ACTION.SET_READ_JOB_INVITATION: {
            var jobInvitationId_1 = payload;
            var newNotifications = JSON.parse(JSON.stringify(state.jobInvitationNotifications));
            newNotifications = newNotifications.map(function (notify) {
                if (notify.jobInvitationId && notify.jobInvitationId === jobInvitationId_1) {
                    notify.isRead = 1;
                }
                return notify;
            });
            return __assign(__assign({}, state), { jobInvitationNotifications: newNotifications });
        }
        default:
            console.error('Unknown type of Reducer');
            return __assign({}, state);
    }
};

export { notificationReducer };
//# sourceMappingURL=reducer.js.map
